import { Page } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { LinkButton } from '@packages/components/link-button';
import { PageToolbar } from '@packages/components/page/page-toolbar';
import { PaperContainer, Typography } from '@packages/fenrir/components';
import { Stack } from '@packages/fenrir/components/stack';
import { useDocumentTitle } from '@packages/fenrir/hooks/use-document-title';
import { PagePlain } from '@packages/fenrir/pages/page-plain';

import { RequestHelp } from './components/request-help/request-help';
import { FlowContent } from './flow-data-content/flow-data-content';

const FlowDataPage = () => {
  const { t } = useTranslation('flow');

  useDocumentTitle(t('title'));

  return (
    <Page.Root>
      <PageToolbar.Root>
        <RequestHelp />
      </PageToolbar.Root>
      <PaperContainer sx={{ width: '100%', padding: 3, marginTop: 2 }}>
        <Stack spacing={3}>
          <Stack spacing={1}>
            <Typography variant="h3" component="h1">
              {t('title')}
            </Typography>
            <Typography variant="body2">
              {t('subTitle', {
                documentationLink: (
                  <LinkButton
                    key="documentation_url"
                    variant="inline"
                    to={t('trafficFlowDocumentationUrl')}
                    external
                  >
                    <strong>{t('trafficFlowDocumentation')}</strong>
                  </LinkButton>
                ),
              })}
            </Typography>
          </Stack>

          <FlowContent />
        </Stack>
      </PaperContainer>
    </Page.Root>
  );
};

export default FlowDataPage;

export const Component = () => {
  const { t } = useTranslation('flow');
  return (
    <PagePlain title={t('title')}>
      <FlowDataPage />
    </PagePlain>
  );
};
